import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom'

import { fetchUser } from './utlis/fetchUser';
import Login from './components/Login';
import Home from './container/Home';
function App() {
  const navigate = useNavigate();

  useEffect(() => {
    const user = fetchUser()
    
    if(!user){
      navigate('/login')
    }
    
  }, []);
  
  return( 
    <Routes>
        <Route path="login" element={<Login/>} />
        <Route path="/*" element={<Home />}/>
        Hello World!
    </Routes>
  )
}

export default App;
